// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"16788":"d59c65e603732184","66649":"4dfa2e3f2030ae9f"}[chunkId] + ".css";
};